import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

interface IProps {
  value: string;
  onChange: (value: string) => void;
}

const SORT_OPTIONS: { value: string; label: string }[] = [
  { value: 'createdAt:desc', label: 'Più recenti' },
  { value: 'createdAt:asc', label: 'Più vecchie' },
  { value: 'email:asc', label: 'Email A-Z' },
  { value: 'email:desc', label: 'Email Z-A' },
];

const ConsultationRequestsSortSelect = ({ value, onChange }: IProps) => {
  return (
    <FormControl size="small" sx={{ minWidth: 180 }}>
      <InputLabel id="consultation-requests-sort-label">Ordina per</InputLabel>
      <Select
        labelId="consultation-requests-sort-label"
        label="Ordina per"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {SORT_OPTIONS.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default ConsultationRequestsSortSelect;
